import axios from 'axios';

export default {
  state: {
    errors: [],
    notifications: [],
    messages: [],
    scores: [],
  },
  mutations: {
    addError(state, error) {
      state.errors.push(error);
    },
    deleteError(state, error) {
      state.errors.splice(state.errors.indexOf(error), 1);
    },
    addNotification(state, notification) {
      state.notifications.push(notification);
    },
    deleteNotification(state, notification) {
      state.notifications.splice(state.notifications.indexOf(notification), 1);
    },
    addMessage(state, message) {
      state.messages.push(message);
    },
    addScore(state, score) {
      state.scores.push(score);
    },
    deleteScore(state, score) {
      state.scores.splice(state.scores.indexOf(score), 1);
    },
    deleteMessage(state, message) {
      state.messages.splice(state.messages.indexOf(message), 1);
    },
  },
  actions: {
    async fetchNotifications({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/notifications/all`, params)
          .then((response) => {
            commit;
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async createNotification({ commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/notifications/create`, params)
          .then((response) => {
            commit;
            result = response.data;
          })
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    addError({ commit }, error) {
      commit('addError', error);
      setTimeout(() => {
        commit('deleteError', error);
      }, 4000);
    },
    addNotification({ commit }, notification) {
      commit('addNotification', notification);
      setTimeout(() => {
        commit('deleteNotification', notification);
      }, notification.duration ? notification.duration : 6000);
    },
    addMessage({ commit }, message) {
      commit('addMessage', message);
      setTimeout(() => {
          commit('deleteMessage', message)
      }, 10000)
    },
    addScore({ commit }, score) {
      commit('addScore', score);
      
      setTimeout(() => {
          commit('deleteScore', score)
      }, 20000)
    },
    deleteScore({ commit }, score) {
      commit('deleteScore', score);
    },
    deleteError({ commit }, error) {
      commit('deleteError', error);
    },
    deleteNotification({ commit }, notification) {
      commit('deleteNotification', notification);
    },
    deleteMessage({ commit }, message) {
      commit('deleteMessage', message);
    },
  },
  getters: {
    getErrors: (s) => s.errors,
    getNotifications: (s) => s.notifications,
    getMessages: (s) => s.messages,
    getScores: (s) => s.scores,
  },
};
